import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const sectionIds = ['home', 'about', 'services', 'industries', 'projects', 'careers', 'contact'];

export default function PublicLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';
  const [activeSection, setActiveSection] = useState(isHomePage ? 'home' : '');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(!isHomePage);

  useEffect(() => {
    setIsMenuOpen(false);
    setIsScrolled(!isHomePage || window.scrollY > 50);
    if (!isHomePage && location.pathname.startsWith('/blogs')) {
      setActiveSection('blogs');
    } else if (isHomePage) {
      setActiveSection('home');
    }
  }, [isHomePage, location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(!isHomePage || window.scrollY > 50);

      if (!isHomePage) return;

      const currentSection = sectionIds.find((section) => {
        const element = document.getElementById(section);
        if (!element) return false;
        const rect = element.getBoundingClientRect();
        return rect.top <= 100 && rect.bottom >= 100;
      });

      if (currentSection) {
        setActiveSection(currentSection);
      }
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isHomePage]);

  useEffect(() => {
    if (!isHomePage) return;

    const section = new URLSearchParams(location.search).get('section');
    if (!section) return;

    const timer = window.setTimeout(() => {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        setActiveSection(section);
      }
      navigate('/', { replace: true });
    }, 50);

    return () => window.clearTimeout(timer);
  }, [isHomePage, location.search, navigate]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [location.pathname]);

  const scrollToSection = (sectionId) => {
    if (!isHomePage) {
      navigate(`/?section=${sectionId}`);
      return;
    }

    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
    setIsMenuOpen(false);
  };

  const openBlogs = () => {
    navigate('/blogs');
    setIsMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-950">
      <Header
        activeSection={activeSection}
        isMenuOpen={isMenuOpen}
        isScrolled={isScrolled}
        setIsMenuOpen={setIsMenuOpen}
        scrollToSection={scrollToSection}
        openBlogs={openBlogs}
      />
      <main>
        <Outlet context={{ scrollToSection }} />
      </main>
      <Footer scrollToSection={scrollToSection} openBlogs={openBlogs} />
    </div>
  );
}
